export const getInflectedWord = (number: number, wordsArr: string[]): string => {
  const options = [2, 0, 1, 1, 1, 2]

  return wordsArr[
    number % 100 > 4 && number % 100 < 20 ? 2 : options[number % 10 < 5 ? number % 10 : 5]
  ]
}
// https://smartlanding.biz/js-sklonenie.html
